module.exports = __webpack_public_path__ + "static/images/mall-pople.b374b65.png";